import './modules/steps';
import './modules/multiple-choice';
import './modules/info-image';
import './modules/slider';

window.Quiz = {};
